/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum NotificationTarget {
    Message = 0,
    Error = 1,
    ServiceAskMeSenpai = 3,
    ServiceToDoList = 4,
    ServicePartnerlist = 5,
}
